import { isNil } from 'lodash-es';
import { useSearchParams } from 'next/navigation';

const USER_ID_KEY = 'userId';

export default function useQueryHandleWithUserId({
  fallbackKey,
}: {
  fallbackKey?: string;
} = {}) {
  const params = useSearchParams();

  function getCurrentUserId() {
    return (
      params.get(USER_ID_KEY) ||
      (!isNil(fallbackKey) ? params.get(fallbackKey) : undefined) ||
      undefined
    );
  }

  function hasUserId() {
    return Boolean(getCurrentUserId());
  }

  function makePathWithUserId(path: string) {
    return `${path}?${USER_ID_KEY}=${getCurrentUserId()}`;
  }

  return {
    USER_ID_KEY,
    hasUserId,
    getCurrentUserId,
    makePathWithUserId,
  };
}
